module.exports = __webpack_public_path__ + "static/img/card_3_1.d4b7e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_3_1.png
// module id = CSpO
// module chunks = 0